module.exports = __webpack_public_path__ + "static/media/vm_chill_frozen.957770ef.png";